module.exports = __webpack_public_path__ + "img/62.0f712b56.png";